// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_1xvFU","controls":"m1WV5"};